import React from "react";

const Employees = React.lazy(() => import("./index"));
const EmployeeDetail = React.lazy(() => import("./EmployeeDetail"));
const AddEditEmployee = React.lazy(() => import("./AddEditEmployee"));
const AddDocument = React.lazy(() =>
  import("./EmployeeDetail/Documents/AddDocument")
);
const DocumentDetail = React.lazy(() =>
  import("./EmployeeDetail/Documents/DocumentDetail")
);
const UserDeviceDetail = React.lazy(() =>
  import("../UserFeatures/UserDevices/UserDeviceDetail")
);

export const EmployeeRoutes = [
  { path: "/admin/employees", name: "Employees", element: <Employees /> },
  {
    path: "/admin/employees/:id",
    name: "EmployeeDetail",
    element: <EmployeeDetail />,
  },
  {
    path: "/admin/employees/create",
    name: "AddEditEmployee",
    element: <AddEditEmployee />,
  },
  {
    path: "/admin/employees/update/:id",
    name: "AddEditEmployee",
    element: <AddEditEmployee />,
  },
  {
    path: "/admin/employees/:id/addDocument",
    name: "AddDocument",
    element: <AddDocument />,
  },
  {
    path: "/admin/employees/:id/document/:documentId",
    name: "DocumentDetail",
    element: <DocumentDetail />,
  },
  {
    path: "/admin/employees/:id/userDevice/:userDeviceId",
    name: "UserDeviceDetail",
    element: <UserDeviceDetail />,
  },
];
